import useDocumentTitle from "../hooks/useDocumentTitle";
import {useDispatch} from "react-redux";
import React, {useState} from "react";
import {resetMenu} from "../redux/slices/menuSlice";
import EntityApi from "../api/EntityApi";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRemove, faEdit} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";
import ModalConfirm from "../components/main/ModalConfirm";
import UserApi from "../api/UserApi";
import {
    Button as ButtonAntd,
    Modal,
    Input,
    Checkbox,
    notification,
    Tooltip,
    Select,
    Table,
    Badge,
    Pagination,
    Radio,
    Space,
    Image
} from "antd";
import Button from "../components/element/Button";
import {SearchOutlined, SendOutlined} from '@ant-design/icons';
import RequestApi from "../api/RequestApi";
import useAuth from "../hooks/useAuth";
import {EmailFunc} from "../func/StringFunc";

const UsersPage = () => {

    const { roles }  = useAuth();
    const navigate = useNavigate();
    const [apiNotification, contextHolder] = notification.useNotification();
    const [items, setItems] = React.useState([]);
    const [isRemoveOpen, setIsRemoveOpen] = React.useState(false);
    const [removeId, setRemoveId] = React.useState(0);
    const [isReload, setIsReload] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [total, setTotal] = React.useState(0);
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);
    const [sortField, setSortField] = useState('id');
    const [sortOrder, setSortOrder] = useState('desc');
    const [filter, setFilter] = useState({});

    // add user
    const [isAddOpen, setAddOpen] = React.useState(false);
    const [formName, setFormName] = React.useState('');
    const [formSurname, setFormSurname] = React.useState('');
    const [formFatherName, setFormFatherName] = React.useState('');
    const [formCompany, setFormCompany] = React.useState('');
    const [formCompanyInn, setFormCompanyInn] = React.useState('');
    const [formLogin, setFormLogin] = React.useState('+7 ');
    const [formEmail, setFormEmail] = React.useState('');
    const [formSendEmail, setFormSendEmail] = React.useState(true);
    const [formSendSms, setFormSendSms] = React.useState(false);
    const [isErrorName, setErrorName] = React.useState(false);
    const [isErrorSurname, setErrorSurname] = React.useState(false);
    const [isErrorLogin, setErrorLogin] = React.useState(false);
    const [isErrorEmail, setErrorEmail] = React.useState(false);

    // send info user
    const [isSenderOpen, setSenderOpen] = React.useState(false);
    const [recipientUserId, setRecipientUserId] = React.useState(0);
    const [recipientType, setRecipientType] = React.useState('email');

    // search
    const [searchClient, setSearchClient] = React.useState('');
    const [searchBlocked, setSearchBlocked] = React.useState(0);
    const [searchCompany, setSearchCompany] = React.useState('');
    const [searchRole, setSearchRole] = React.useState('');

    useDocumentTitle('Список пользователей')
    const dispatch = useDispatch();
    React.useEffect(() => {
        dispatch(resetMenu());
    }, [])

    React.useEffect(() => {
        setIsLoading(true);
        EntityApi.getBy('private/user', {
            filter: filter,
            sort: {
                [sortField]: sortOrder
            },
            page: page,
            size: pageSize
        }).then((data) => {
            if (data.status === EntityApi.STATUS_SUCCESS) {
                setItems(data.content.items);
                setTotal(data.payload.total);
                setPage(data.payload.currentPage);
            }
            setIsLoading(false);
        }).catch(() => {
            setIsLoading(false);
        })

    }, [isReload]);

    const goToProfile = (id) => {
        navigate('/cabinet/users/' + id);
    }

    const onRemove = () => {
        setIsRemoveOpen(false);
        if (removeId > 0) {
            UserApi.delete(removeId).then(data => {
                setIsReload(!isReload);
            });
        }
        setRemoveId(0);
    }

    const openModalRemove = (id) => {
        setIsRemoveOpen(true);
        setRemoveId(id);
    }

    const onAdd = () => {

        let isError = false;
        let login = formLogin.replace(/\D/g, '');

        setErrorName(false);
        setErrorSurname(false);
        setErrorEmail(false);
        setErrorLogin(false);

        if (formName.length < 2) {
            isError = true;
            setErrorName(true);
        }

        if (formSurname.length < 2) {
            isError = true;
            setErrorSurname(true);
        }

        if (formEmail === '' || formEmail.length < 8 || !EmailFunc.isValid(formEmail)) {
            isError = true;
            setErrorEmail(true);
        }

        if (login === '' || login.length < 11) {
            isError = true;
            setErrorLogin(true);
        }

        if (!isError) {
            EntityApi.put('private/user-add', {
                login: login,
                name: formName,
                surname: formSurname,
                fatherName: formFatherName,
                company: formCompany,
                companyInn: formCompanyInn,
                email: formEmail,
                is_send_email: formSendEmail,
                is_send_sms: formSendSms
            }).then((data) => {
                if (data.status == EntityApi.STATUS_SUCCESS) {
                    setAddOpen(false);
                    setFormName('');
                    setFormSurname('');
                    setFormFatherName('');
                    setFormLogin('');
                    setFormEmail('');
                    setFormCompany('');
                    setFormCompanyInn('');
                    setFormSendEmail(true);
                    setFormSendSms(false);
                    setErrorName(false);
                    setErrorSurname(false);
                    setErrorEmail(false);
                    setErrorLogin(false);
                    setIsReload(!isReload);
                } else {
                    var mes = '';
                    data.error.messages.forEach((message) => {
                        mes +=  '' + message;
                    })
                    apiNotification['error']({
                        message: 'Ошибка добавления пользователя',
                        description: mes,
                    });
                }
            }).catch(() => {
                apiNotification['error']({
                    message: 'Ошибка сервера',
                    description:
                        'Произошла ошибка сервера, пожалуйста, обратитесь к разработчику',
                });
            })
        }

    }

    const onSendInformation = () => {
        RequestApi.post('private/user-send-information', {
            'id': recipientUserId,
            'type': recipientType
        }).then((data) => {
            if (data.status === RequestApi.STATUS_SUCCESS) {
                setSenderOpen(false);
                apiNotification['success']({
                    message: 'Данные отправлены',
                    description:
                        'Данные успешно отправлены на ' + data.content.recipient,
                });
            } else {
                apiNotification['error']({
                    message: 'Ошибка отправки информации',
                    description: 'Попробуйте еще раз или обратитесь к разработчику',
                });
            }
        })
    }

    const handleChangeLogin = (event) => {

        let formatted = '';

        let numbersOnly = event.target?.value.replace(/\D/g, '');

        if (numbersOnly.length > 0) {
            formatted += '+7 ';
        }
        if (numbersOnly.length > 1) {
            formatted += '(' + numbersOnly.substring(1, 4);
        }
        if (numbersOnly.length > 4) {
            formatted += ') ' + numbersOnly.substring(4, 7);
        }
        if (numbersOnly.length > 7) {
            formatted += '-' + numbersOnly.substring(7, 9);
        }
        if (numbersOnly.length > 9) {
            formatted += '-' + numbersOnly.substring(9, 11);
        }


        setFormLogin(formatted);
    }

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter.hasOwnProperty("column")) {
            if (sorter.field !== undefined) {
                setSortField(sorter.field);
            } else {
                if (sorter.field === 'name') {
                    sorter.field = 'surname';
                }
                setSortField('id');
            }
            if (sorter.order === 'ascend') {
                setSortOrder('asc');
            }
            if (sorter.order === 'descend') {
                setSortOrder('desc');
            }
        } else {
            setSortField('id');
            setSortOrder('desc');
        }
        setIsReload(!isReload);
    }

    const onPaginate = (p) => {
        setPage(p);
        setIsReload(!isReload);
    }

    const handleSearch = (confirm) => {
        let preFilter = {
            client: searchClient,
            blocked: searchBlocked,
            company: searchCompany,
            role: searchRole,
        };
        setFilter(preFilter);
        confirm();
        setIsReload(!isReload);
    }

    const handleResetField = (field, confirm) => {
        setSearchClient('');
        setSearchBlocked(0);
        setSearchCompany('');
        setSearchRole('');
        setFilter({});
        confirm();
        setIsReload(!isReload);
    }

    const getColumnSearchBlocked = () => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => {
            return <>
                <div className={'p-2'}>
                    <Radio.Group onChange={(e) => setSearchBlocked(e.target.value)} value={searchBlocked}>
                        <Space direction="vertical">
                            <Radio value={0}>Все</Radio>
                            <Radio value={1}>Заблокирован</Radio>
                            <Radio value={2}>Не заблокирован</Radio>
                        </Space>
                    </Radio.Group>
                </div>
                <div className={'flex p-2'}>
                    <ButtonAntd className={'mr-2'} type={'primary'} onClick={() => handleSearch(confirm)}>Найти</ButtonAntd>
                    <ButtonAntd type={'default'} onClick={() => handleResetField('blocked', confirm)}>Сбросить</ButtonAntd>
                </div>
            </>
        },
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        )
    });

    const getColumnSearchClient = () => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => {
            return <>
                <div className={'flex p-2'}>
                    <Input placeholder={'Имя, логин, e-mail'}
                           onPressEnter={() => handleSearch(confirm)} value={searchClient} onChange={(evt) => setSearchClient(evt.target.value)} />
                </div>
                <div className={'flex p-2'}>
                    <ButtonAntd className={'mr-2'} type={'primary'} onClick={() => handleSearch(confirm)}>Найти</ButtonAntd>
                    <ButtonAntd type={'default'} onClick={() => handleResetField('client', confirm)}>Сбросить</ButtonAntd>
                </div>
            </>
        },
        filterIcon: (filtered) => (
        <SearchOutlined
            style={{
                color: filtered ? '#1677ff' : undefined,
            }}
        />
    )
    });

    const getColumnSearchCompany = () => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => {
            return <>
                <div className={'flex p-2'}>
                    <Input placeholder={'Название компании'}
                           onPressEnter={() => handleSearch(confirm)} value={searchCompany} onChange={(evt) => setSearchCompany(evt.target.value)} />
                </div>
                <div className={'flex p-2'}>
                    <ButtonAntd className={'mr-2'} type={'primary'} onClick={() => handleSearch(confirm)}>Найти</ButtonAntd>
                    <ButtonAntd type={'default'} onClick={() => handleResetField('client', confirm)}>Сбросить</ButtonAntd>
                </div>
            </>
        },
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        )
    });

    const getColumnSearchRoles = () => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => {
            return <>
                <div className={'p-2'}>
                    <Radio.Group onChange={(e) => setSearchRole(e.target.value)} value={searchRole}>
                        <Space direction="vertical">
                            <Radio value={''}>Все</Radio>
                            <Radio value={'ROLE_MANAGER'}>Менеджер</Radio>
                            <Radio value={'ROLE_PARTNER'}>Партнер</Radio>
                            <Radio value={'ROLE_ADMIN'}>Администратор</Radio>
                        </Space>
                    </Radio.Group>
                </div>
                <div className={'flex p-2'}>
                    <ButtonAntd className={'mr-2'} type={'primary'} onClick={() => handleSearch(confirm)}>Найти</ButtonAntd>
                    <ButtonAntd type={'default'} onClick={() => handleResetField('blocked', confirm)}>Сбросить</ButtonAntd>
                </div>
            </>
        },
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        )
    });

    /* table */
    const columns = [
        {
            title: 'Клиент',
            responsive: ['xs'],
            ...getColumnSearchClient(),
            render: (item) => {
                return <>
                    <div><span className={'font-bold'}>ID: </span>{item.id}</div>
                    <div><span className={'font-bold'}>Блок. </span>{item.active ?
                        <Badge status="success" text={'Нет'}/> : <Badge status="error" text={'Да'}/>}</div>
                    <div><span className={'font-bold'}>Логин: </span>{item.login}</div>
                    <div><span className={'font-bold'}>E-mail: </span>{item.email}</div>
                    <div><span className={'font-bold'}>Имя: </span>{item.name}</div>
                    <div><span className={'font-bold'}>Компания: </span>{item.company}</div>
                    {(roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER')) &&
                        <div>
                            <span className={'font-bold'}>Роль: </span>
                            {item.roles.includes('ROLE_MANAGER') && <span>Менеджер</span>}
                            {item.roles.includes('ROLE_ADMIN') && <span>Администратор</span>}
                            {item.roles.includes('ROLE_PARTNER') && <span>Партнер</span>}
                            {!item.roles.includes('ROLE_ADMIN') &&
                                !item.roles.includes('ROLE_MANAGER') &&
                                !item.roles.includes('ROLE_PARTNER') &&
                                <span>Пользователь</span>}
                        </div>
                    }
                    <div className="flex justify-center items-center space-x-2 mt-2">
                        {
                            roles.includes('ROLE_ADMIN') &&
                            <Tooltip title="Отправить данные">
                                <ButtonAntd size={'small'} onClick={() => {
                                    setSenderOpen(true);
                                    setRecipientUserId(item.id)
                                }}><SendOutlined/></ButtonAntd>
                            </Tooltip>
                        }
                        <Tooltip title="Просмотр">
                            <button onClick={() => goToProfile(item.id)}
                                    className="btn h-8 w-8 p-0 text-info hover:bg-info/20 focus:bg-info/20 active:bg-info/25">
                                <FontAwesomeIcon icon={faEdit}/>
                            </button>
                        </Tooltip>
                        {
                            roles.includes('ROLE_ADMIN') &&
                            <Tooltip title="Удалить">
                                <button onClick={() => openModalRemove(item.id)}
                                        className="btn h-8 w-8 p-0 text-error hover:bg-error/20 focus:bg-error/20 active:bg-error/25">
                                    <FontAwesomeIcon icon={faRemove}/>
                                </button>
                            </Tooltip>
                        }
                    </div>
                </>
            }
        },
        {
            title: 'ID',
            width: 100,
            dataIndex: 'id',
            responsive: ['md'],
            sorter: true,
        },
        {
            title: 'Блок.',
            width: 100,
            dataIndex: 'active',
            responsive: ['md'],
            render: (active) => <span>{active ? <Badge status="success" text={'Нет'}/> :
                <Badge status="error" text={'Да'}/>}</span>,
            ...getColumnSearchBlocked()
        },
        {
            title: 'Логин',
            dataIndex: 'login',
            responsive: ['md'],
            ...getColumnSearchClient(),
        },
        {
            title: 'E-mail',
            dataIndex: 'email',
            responsive: ['md'],
            ...getColumnSearchClient(),
        },
        {
            title: 'Имя',
            dataIndex: 'name',
            responsive: ['md'],
            sorter: true,
            ...getColumnSearchClient(),
            render: (name, record) => {
                return <div className={'flex'}>
                    <div className={'pr-2'} style={{height: '24px'}}>
                        {
                            record.avatar ? (
                                <Image
                                    className="rounded-full"
                                style={{height: '24px'}}
                                src={record.avatar}
                                preview={{
                                    mask: <span></span>,
                                    maskClassName: 'hover-user-avatar',
                                    src: record.avatar.replace("_100", "_orig"),
                                }}
                            />
                            ) : (
                                <img
                                    className="rounded-full"
                                    style={{height: '24px'}}
                                    src="/images/100x100.png"
                                    alt="avatar"
                                />
                            )
                        }
                    </div>
                    <div>{name}</div>
                </div>
            }
        },
        {
            title: 'Компания',
            responsive: ['md'],
            dataIndex: 'company',
            ...getColumnSearchCompany()
        }
    ]

    if (roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER')) {
        columns.push({
            title: 'Роли',
            dataIndex: 'roles',
            responsive: ['md'],
            render: (roles) => {
                return <div>
                    { roles.includes('ROLE_MANAGER') && <span>Менеджер</span> }
                    { roles.includes('ROLE_ADMIN') && <span>Администратор</span> }
                    { roles.includes('ROLE_PARTNER') && <span>Партнер</span> }
                    { !roles.includes('ROLE_ADMIN') &&
                        !roles.includes('ROLE_MANAGER') &&
                        !roles.includes('ROLE_PARTNER') &&
                        <span>Пользователь</span> }
                </div>
            },
            ...getColumnSearchRoles()
        });
    }

    columns.push({
        width: 200,
        responsive: ['md'],
        render: (item) => {
            return <div className="flex justify-center items-center space-x-2">
                {
                    roles.includes('ROLE_ADMIN') &&
                    <Tooltip title="Отправить данные">
                        <ButtonAntd size={'small'} onClick={() => {
                            setSenderOpen(true);
                            setRecipientUserId(item.id)
                        }}><SendOutlined/></ButtonAntd>
                    </Tooltip>
                }
                <Tooltip title="Просмотр">
                    <button onClick={() => goToProfile(item.id)}
                            className="btn h-8 w-8 p-0 text-info hover:bg-info/20 focus:bg-info/20 active:bg-info/25">
                        <FontAwesomeIcon icon={faEdit}/>
                    </button>
                </Tooltip>
                {
                    roles.includes('ROLE_ADMIN') &&
                    <Tooltip title="Удалить">
                        <button onClick={() => openModalRemove(item.id)}
                                className="btn h-8 w-8 p-0 text-error hover:bg-error/20 focus:bg-error/20 active:bg-error/25">
                            <FontAwesomeIcon icon={faRemove}/>
                        </button>
                    </Tooltip>
                }
            </div>
        }
    });

    return <>
        {contextHolder}
        <div className="flex items-center justify-between py-5 lg:py-6">
            <div className="flex items-center space-x-1">
                <h2 className="line-clamp-1 text-xl font-medium text-slate-700 dark:text-navy-50 lg:text-2xl">
                    Список пользователей
                </h2>
            </div>
        </div>
        <div className="card px-4 pb-4">
            <div className="my-3 flex h-8 items-center justify-between">
                <h2 className="line-clamp-1 font-medium tracking-wide text-slate-700 dark:text-navy-100 lg:text-base">
                    Пользователи
                </h2>
                <ButtonAntd type={'default'} onClick={() => setAddOpen(true)}>+ Добавить</ButtonAntd>
            </div>

            <Table rowKey={'id'} loading={isLoading} onChange={handleTableChange} columns={columns} dataSource={items} pagination={false}></Table>
            <div className={'pt-3'}>
                <Pagination defaultCurrent={page} pageSize={pageSize} showSizeChanger={true} onShowSizeChange={(current, size) => setPageSize(size)} onChange={onPaginate} total={total}/>
            </div>
        </div>
        <ModalConfirm title={'Удаление пользователя'} text={'Вы действительно хотите удалить этого пользователя?'}
                      cancelText={"Отменить"} confirmText={"Удалить"} onConfirm={onRemove}  isOpen={isRemoveOpen} onClose={() => setIsRemoveOpen(false)}/>
        <Modal
            title="Добавить пользователя"
            open={isAddOpen}
            onCancel={() => setAddOpen(false)}
            footer={(_, { OkBtn, CancelBtn }) => (
                <div className={'flex'}>
                    <div className={'w-6/12 pr-2'}>
                        <Button text={'Отмена'} onClick={() => setAddOpen(false)}/>
                    </div>
                    <div className={'w-6/12'}>
                        <Button text={'Добавить'} onClick={onAdd} type={'primary'}/>
                    </div>
                </div>
            )}
        >
            <div className={'pb-3 flex'}>
                <div className={'w-6/12'}>Фамилия: *</div>
                <Input value={formSurname} status={isErrorSurname ? 'error' : ''} onChange={(evt) => setFormSurname(evt.target.value)} />
            </div>
            <div className={'pb-3 flex'}>
                <div className={'w-6/12'}>Имя: *</div>
                <Input value={formName} status={isErrorName ? 'error' : ''} onChange={(evt) => setFormName(evt.target.value)} />
            </div>
            <div className={'pb-3 flex'}>
                <div className={'w-6/12'}>Отчество: </div>
                <Input value={formFatherName} onChange={(evt) => setFormFatherName(evt.target.value)} />
            </div>
            <div className={'pb-3 flex'}>
                <div className={'w-6/12'}>Номер телефона: *</div>
                <Input value={formLogin} status={isErrorLogin ? 'error' : ''} onChange={handleChangeLogin} />
            </div>
            <div className={'pb-3 flex'}>
                <div className={'w-6/12'}>E-mail: *</div>
                <Input value={formEmail} status={isErrorEmail ? 'error' : ''} onChange={(evt) => setFormEmail(evt.target.value)} />
            </div>
            <div className={'pb-3 flex'}>
                <div className={'w-6/12'}>Организация: </div>
                <Input value={formCompany} onChange={(evt) => setFormCompany(evt.target.value)} />
            </div>
            <div className={'pb-3 flex'}>
                <div className={'w-6/12'}>ИНН Организации: </div>
                <Input value={formCompanyInn} onChange={(evt) => setFormCompanyInn(evt.target.value)} />
            </div>
            <div className={'pb-3 flex'}>
                <Checkbox checked={formSendEmail} onChange={(evt) => setFormSendEmail(evt.target.checked)}>
                    Отправить пароль на E-mail
                </Checkbox>
            </div>
            <div className={'pb-3 flex'}>
                <Checkbox checked={formSendSms} onChange={(evt) => setFormSendSms(evt.target.checked)}>
                    Отправить пароль на телефон по SMS
                </Checkbox>
            </div>
        </Modal>
        <Modal
            title="Отправить данные пользователю"
            open={isSenderOpen} onCancel={() => setSenderOpen(false)}
            okText={'Отправить'}
            onOk={onSendInformation}
        >
            <div className={"pb-2"}>Внимание! При отправке данных, пароль будет изменен</div>
            <Select className={'w-full'} value={recipientType} onChange={(value) => setRecipientType(value)} options={[
                { value: 'email', label: 'Отправить на E-mail' },
                { value: 'phone', label: 'Отправить на номер телефона (по СМС)' },
            ]} />
        </Modal>
    </>

}

export default UsersPage;
